import React from "react";

import { Paper } from "@/components/paper/Paper";
import { CreatePhoneCallForm } from "@/features/phone-call-create/form/CreatePhoneCallForm";

import { ModalCloseCross } from "../components/ModalCloseCross";

type PropTypes = {
  onClose: () => void;
  ladyId: number;
};

export const CreatePhoneCallModal: React.FC<PropTypes> = ({
  onClose,
  ladyId,
}) => {
  return (
    <Paper className="p-4 py-8 md:p-8 w-[400px] max-w-full min-h-min relative">
      <ModalCloseCross absolute onClose={onClose} />
      <CreatePhoneCallForm ladyId={ladyId} />
    </Paper>
  );
};
